/*----------------------------------------------------------------------------*\
  #DATE & TIME
\*----------------------------------------------------------------------------*/

// Add st, nd, rd or th to end of date
const dateOrdinal = date => {
  return date > 20 || date < 10
    ? [false, 'st', 'nd', 'rd'][date % 10] || 'th'
    : 'th';
};

// Matches tokens within an opt-in format string, e.g. "ddd, DD/MM/YY" -> ['ddd', 'DD', 'MM', 'YY']
// Any characters outside of these tokens (spaces, commas, slashes, etc.) are kept as-is.
const DATE_FORMAT_TOKEN_PATTERN = /dddd|ddd|MMMM|MMM|YYYY|YY|DD|D|MM|M/g;

// Render a format string (e.g. "ddd, DD/MM/YY") against a given date, e.g. "Thu, 23/07/2026"
const formatDateFromTokens = (formatString, now) => {
  const tokenValues = {
    dddd: () => now.toLocaleString('default', { weekday: 'long' }), // Thursday
    ddd: () => now.toLocaleString('default', { weekday: 'short' }), // Thu
    MMMM: () => now.toLocaleString('default', { month: 'long' }), // July
    MMM: () => now.toLocaleString('default', { month: 'short' }), // Jul
    MM: () => ('0' + (now.getMonth() + 1)).slice(-2), // 07
    M: () => String(now.getMonth() + 1), // 7
    YYYY: () => String(now.getFullYear()), // 2026
    YY: () => String(now.getFullYear()).slice(-2), // 26
    DD: () => ('0' + now.getDate()).slice(-2), // 03
    D: () => String(now.getDate()), // 3
  };

  return formatString.replace(DATE_FORMAT_TOKEN_PATTERN, token => tokenValues[token]());
};

const setDateTime = () => {
  const $headerdatetime = document.querySelector('.js-header-date-time'); // headerDatetime container element
  if (!$headerdatetime) return null;

  const $longDate = document.querySelector('.js-long-date-wrap'); // Long date container element (only present when weather is shown)

  const $time = $headerdatetime.querySelector('.js-time'); // Time container element
  const $dates = $headerdatetime.querySelectorAll('.js-date'); // Date container element(s) - may be more than one, e.g. a mobile/desktop pair
  const $dateLong = $longDate && $longDate.querySelector('.js-long-date'); // Long date container element

  const _now = new Date(); // Get current date and time
  const day = _now.toLocaleString('default', { weekday: 'short' }); // Mon
  const dayLong = _now.toLocaleString('default', { weekday: 'long' }); // Monday
  const date = `${_now.getDate()}${dateOrdinal(_now.getDate())}`; // 1st
  const timeStamp = _now.toISOString(); // 2020-01-01T00:00:00.201Z
  const hour = ('0' + _now.getHours()).slice(-2); // 00
  const minute = ('0' + _now.getMinutes()).slice(-2); // 00
  const dateLongString = `${dayLong} ${date}`; // Monday 1st
  const timeString = `${hour}:${minute}`; // 00:00

  // Apply time to element
  $time.innerHTML = timeString;

  // Apply date to element(s)
  // Opt-in format via a data-date-format attribute on the element itself, e.g. data-date-format="ddd, DD/MM/YY"
  $dates.forEach($date => {
    const dateFormat = $date.dataset.dateFormat;
    $date.innerHTML = dateFormat
      ? formatDateFromTokens(dateFormat, _now) // Thu, 23/07/2026
      : `${day} ${date}`; // Mon 1st
  });

  // Apply long date to element
  if ($dateLong) $dateLong.innerHTML = dateLongString;

  // Update ISO headerdatetime
  $headerdatetime.setAttribute('headerdatetime', timeStamp);
};

const DateTime = () => {
  let _intervalId = null;

  // Public: Destroy module instance
  const destroy = () => {
    clearInterval(_intervalId);
    _intervalId = null;
  };

  // Public: Destroy module instance and run initialise again
  const reinit = () => {
    destroy();
    init();
  };

  // Public: Initialise module
  const init = () => {
    setDateTime();
    _intervalId = setInterval(setDateTime, 1000); // update every second
  };

  // Return public methods
  return {
    destroy,
    reinit,
    init,
  };
};

// Default module export
export default DateTime;
